import * as React from "react"
import type { SVGProps } from "react"
const SvgUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m12 10.96-3.9 3.9a1 1 0 0 1-.7.28 1 1 0 0 1-.7-.27 1 1 0 0 1-.29-.7 1 1 0 0 1 .28-.7l4.6-4.61q.15-.15.33-.21a1 1 0 0 1 .75 0 1 1 0 0 1 .33.2l4.6 4.62a1 1 0 0 1 .28.7 1 1 0 0 1-.28.7 1 1 0 0 1-.7.27 1 1 0 0 1-.7-.27z" />
  </svg>
)
export default SvgUp
